import React, { PureComponent } from 'react';
import ProductBlock from './ProductBlock.js';
class SpecialityProducts extends PureComponent {
  state = {
    privateLabels: Object.keys(this.props.specialityProductMetaConfigs)
  };
  /**
   * Set all the default values for all the speciality products
   * @returns {Promise<void>}
   */
  async componentDidMount() {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    const specialityProducts = {};
    const promises = this.state.privateLabels.map(async privateLabelID => {
      const privateLabelProduct = this.props.specialityProductMetaConfigs[privateLabelID];
      const promises2 = Object.keys(privateLabelProduct.products).map(specialityProductID => {
        const specialityProduct = privateLabelProduct.products[specialityProductID];
        const defaults = specialityProduct.defaults;
        const currentPlanDesignProductData = this.props.specialityProducts[specialityProductID];
        specialityProducts[specialityProductID] = {
          ...defaults,
          ...currentPlanDesignProductData,
          privateLabelID,
          specialityProductID
        };
      });
      await Promise.all(promises2);
    });
    await Promise.all(promises);
    if (this.props.type === "modular") {
      // save the init data in global state so it's there for the save
      this.props.saveModularBenefitInitData(this.props.classID, null, null, 'specialityProducts', specialityProducts);
      return;
    }
    // save the init data in global state so it's there for the save
    this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'specialityProducts', specialityProducts);
  }
  render() {
    if (this.state.privateLabels.length === 0) {
      return null;
    }
    return this.state.privateLabels.map(privateLabelID => {
      const privateLabelData = this.props.specialityProductMetaConfigs[privateLabelID];
      if (privateLabelData.products.length === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(privateLabelData.products).map(specialityProductID => {
        const productMeta = privateLabelData.products[specialityProductID];
        return /*#__PURE__*/React.createElement(ProductBlock, {
          productMeta: productMeta,
          specialityProducts: this.props.specialityProducts,
          privateLabelID: privateLabelID,
          specialityProductID: productMeta.specialityProductID,
          data: this.props.specialityProducts[specialityProductID],
          name: productMeta.name,
          carrier: productMeta.carrier,
          fields: productMeta.fields,
          revision: this.props.revision,
          isRevisionBlock: this.props.isRevisionBlock,
          whitelabel: this.props.whitelabel,
          savePlanDesignBenefitInitData: this.props.savePlanDesignBenefitInitData,
          savePlanDesignField: this.props.savePlanDesignField,
          selectedClassID: this.props.selectedClassID,
          selectedDesignID: this.props.selectedDesignID,
          errors: this.props.errors ? this.props.errors.specialityProducts : {},
          isMasterSite: this.props.isMasterSite,
          setChangesMadeFlag: this.props.setChangesMadeFlag,
          language: this.props.language
        });
      }));
    });
  }
}
export default SpecialityProducts;